import { forwardRef } from "react";
import CardShell from "./CardShell";
import ContactFooter from "./ContactFooter";
import { gross, lei, resale } from "@/lib/pricing";
import BottlePlaceholder from "./BottlePlaceholder";

const KICKER = "Instant Bond Repair";

const splitName = (name) =>
  name.startsWith(`${KICKER} `) ? [KICKER, name.slice(KICKER.length + 1)] : [null, name];

const pad = (n) => (n ? String(n).padStart(2, "0") : "R2");

const ProductCard = forwardRef(function ProductCard({ product, index, total, contact, markup, vat, pro, treatments }, ref) {
  const [, title] = splitName(product.name);
  const amount = Math.round(gross(product.price, vat)).toLocaleString("ro-RO");
  return (
    <CardShell ref={ref} testId={`product-card-${product.id}`}>
      <header className="mc-head">
        <div>
          <div className="mc-wordmark">MEDAVITA</div>
          <div className="mc-line">Instant Bond Repair</div>
        </div>
        <div className="mc-index" data-testid={`product-card-index-${product.id}`}>
          {pad(index)} <span>/ {pad(total)}</span>
        </div>
      </header>

      <div className="mc-stage">
        <div className="mc-halo" />
        <div className="mc-podium" />
        {product.image ? (
          <img src={product.image} alt={product.name} className="mc-photo" data-testid={`product-card-photo-${product.id}`} />
        ) : (
          <BottlePlaceholder size={product.size} />
        )}
      </div>

      <section className="mc-info">
        {product.category && <div className="mc-chip">{product.category}</div>}
        <h2 className="mc-title" data-testid={`product-card-name-${product.id}`}>{title}</h2>
        <div className="mc-meta">
          <span className="mc-size">{product.size}</span>
          {product.code && <span className="mc-code" data-testid={`product-card-code-${product.id}`}>Cod {product.code}</span>}
        </div>
      </section>

      <section className="mc-price-row">
        <div>
          <div className="mc-price-label">Preț salon</div>
          <div className={`mc-price ${amount.length > 5 ? "mc-price--long" : ""}`} data-testid={`product-card-price-${product.id}`}>
            <span className="mc-price-amount">{amount}</span>
            <span className="mc-price-unit">lei</span>
          </div>
          <div className="mc-vat" data-testid={`product-card-vat-${product.id}`}>TVA {vat}% inclus</div>
        </div>
        {pro ? (
          <div className="mc-resale mc-resale--pro" data-testid={`product-card-pro-${product.id}`}>
            <div className="mc-price-label">Uz profesional</div>
            <b>min. {treatments} tratamente</b>
            <div className="mc-vat">pe set, în salon</div>
          </div>
        ) : (
          <div className="mc-resale" data-testid={`product-card-resale-${product.id}`}>
            <div className="mc-price-label">Preț recomandat vânzare</div>
            <b>{lei(resale(product.price, markup, vat))}</b>
            <div className="mc-vat">TVA inclus</div>
          </div>
        )}
      </section>

      <ContactFooter contact={contact} cta={<>Răspunde cu <b>„{pad(index)}”</b> pt. comandă</>} />
    </CardShell>
  );
});

export default ProductCard;
